import { useFeatureFlag } from '@sparknz/feature-flags';

import useQuery, { Query } from '../useQuery/useQuery.hook';

const ssoParams = {
  code: 'code',
  state: 'state',
  formPostEntry: 'form_post_entry',
};

export function hasSsoQueryParams(query: Query) {
  const code = query[ssoParams.code];
  const state = query[ssoParams.state];
  const formPostEntry = query[ssoParams.formPostEntry];

  return Boolean(formPostEntry || (code && state));
}

export default function useForgerockParams() {
  const { value: forgerockEnabled } = useFeatureFlag(
    'release-enable-forgerock-login-modal',
  );
  const { query, replaceQuery } = useQuery();

  return {
    forgerockEnabled,
    hasSsoQueryParams: forgerockEnabled && hasSsoQueryParams(query),
    removeSsoQueryParams: () => {
      if (!forgerockEnabled) return;
      const {
        [ssoParams.code]: _code,
        [ssoParams.state]: _state,
        [ssoParams.formPostEntry]: _formPostEntry,
        ...rest
      } = query;

      replaceQuery(rest);
    },
  };
}
